import { render } from "./WRSList.vue?vue&type=template&id=3d452744&scoped=true&ts=true"
import script from "./WRSList.ts?vue&type=script&lang=ts"
export * from "./WRSList.ts?vue&type=script&lang=ts"

import "./WRSList.vue?vue&type=style&index=0&id=3d452744&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d452744"]])

export default __exports__